module.exports = {
          srcSet: __webpack_public_path__ + "static/media/streets-thumb@2x.147a7027.webp"+" 140w",
          images:[ {path: __webpack_public_path__ + "static/media/streets-thumb@2x.147a7027.webp",width: 140,height: 140}],
          src: __webpack_public_path__ + "static/media/streets-thumb@2x.147a7027.webp",
          toString:function(){return __webpack_public_path__ + "static/media/streets-thumb@2x.147a7027.webp"},
          placeholder: undefined,
          width: 140,
          height: 140
      }